import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
// import GD from '../../RestAPI/getData';
import cookie from 'react-cookies';
//import { FacebookLogin } from 'react-facebook-login-component';
import GoogleLogin from 'react-google-login';
import TagManager from 'react-gtm-module';
import language from '../../../assets/languages/language';
import SignUpApproval from '../../Common/signUpApproval';
import './Auth.css';
// import { getDeviceDetails } from "../../../common/deviceDetails";
import Cookies from 'universal-cookie';
import {
  ActuarialExamList,
  CFAExamList,
  FRMExamList,
  GA4SignUp,
  GMATExamList,
  GTMSignUp,
  GTM_ID,
  examObject,
} from '../../../common/constant';
import { getIpAddress } from '../../../common/getIpAddress';
import { examRedirectRoute } from '../../Common/examRedirectRoute';
import AppRoutes from '../../config/AppRoutes';
import GoogleBtn from "../../../components/GoogleBtn";
import {parseIdToken} from "../../../common/helper";

/* eslint-disable*/
class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      email: '',
      password: '',
      repeatpassword: '',
      message: '',
      userNameErrorMessage: '',
      emailErrorMessage: '',
      passwordErrorMessage: '',
      repPasswordErrorMessage: '',
      locErrorMessage: '',
      examErrorMessage: '',
      urlToRedirect: '',
      signupAlert: false,

      landingSource: 'organic',
      landingSourceName: null,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.updateUserName = this.updateUserName.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.updateRepeatPassword = this.updateRepeatPassword.bind(this);
    this.Registration = this.Registration.bind(this);
    this.signUpAlertModel = this.signUpAlertModel.bind(this);
    this.signUpAlertModelClose = this.signUpAlertModelClose.bind(this);
    this.responseGoogle = this.responseGoogle.bind(this);
    this.failedGoogle = this.failedGoogle.bind(this);
  }

  signUpAlertModel() {
    this.setState({
      signupAlert: !this.state.signupAlert,
    });
  }
  signUpAlertModelClose() {
    this.setState({
      signupAlert: false,
    });
    browserHistory.push('/');
  }

  socialQQLogin(e) {
    e.preventDefault();
    var data = { idname: '1223' };

    FD.callAPI(App_data.backend_api + '/user/socialLoginQQ', data).then((resp) => {
      if (resp.success) {
        window.open(resp.result, '_self');
      }
    });
  }

  async componentDidMount() {
    // api to get ip address
    const result1 = await getIpAddress();
    if (result1) {
      this.setState({
        user_city: result1.city,
        user_country: result1.country,
        user_ip: result1.query,
        user_state: result1.region,
        user_continent: result1.continent,
      });
      const data1 = {
        city: result1.city,
        country: result1.country,
        state: result1.region,
        continent: result1.continent,
        ip: result1.query,
      };
      localStorage.setItem('userData', JSON.stringify(data1));
    }
    // const result = getDeviceDetails();
    // const data1 = {
    //   city: this.state.user_city,
    //   country: this.state.user_country,
    //   state: this.state.user_state,
    //   continent: this.state.user_continent,
    //   ip: this.state.user_ip,
    // };
    // localStorage.setItem("userData", JSON.stringify(data1));
    /*
--------------------------------
  Pixel Integration code start
--------------------------------
*/
    let landingSourceCokkie = cookie.load('utm_source', {
      path: '/',
      domain: '.analystprep.com',
    });
    if (landingSourceCokkie) {
      this.setState({
        landingSource: landingSourceCokkie,
      });
    }
    localStorage.setItem('landingSource', landingSourceCokkie ? landingSourceCokkie : null);
    let checkTapfilliateRefernce = cookie.load('ref', {
      path: '/',
      domain: '.analystprep.com',
    });
    if (checkTapfilliateRefernce) {
      this.setState({
        landingSource: 'tapfiliate',
        landingSourceName: checkTapfilliateRefernce,
      });
      localStorage.setItem('landingSource', 'tapfiliate');
    }

    localStorage.setItem(
      'landingSourceName',
      checkTapfilliateRefernce ? checkTapfilliateRefernce : null,
    );
    /*
-------------------------------
  Pixel Integration code end
-------------------------------
    */
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    {
      this.props.urlToRedirect !== null
        ? this.setState({ urlToRedirect: this.props.urlToRedirect })
        : this.setState({ urlToRedirect: null });
    }

    if (storage_session) {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
      };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then((resp) => {
        if (resp.success) {
          if (resp.profileInfo.exam) {
            localStorage.setItem('selectedmenu', resp.profileInfo.exam);
            browserHistory.push({
              pathname: examRedirectRoute[resp.profileInfo.exam],
              state: {
                token: storage_session['token'],
                idname: storage_session['idname'],
              },
            });
          }
        }
      });
    }
  }

  componentWillReceiveProps() {
    this.setState({
      message: '',
      userNameErrorMessage: '',
      emailErrorMessage: '',
      passwordErrorMessage: '',
      repPasswordErrorMessage: '',
      locErrorMessage: '',
      examErrorMessage: '',
    });
  }

  Registration(event) {
    event.preventDefault();
    if (this.state.username === '') {
      this.setState({ displaytext: 'show_block' });
      this.setState({
        userNameErrorMessage: `${language.LC().User_Name_is_Required}`,
      });
      return;
    }
    if (this.state.email === '') {
      this.setState({ displaytext: 'show_block' });
      this.setState({
        emailErrorMessage: `${language.LC().Email_is_Required}`,
      });
      return;
    }
    var emailValid = this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    if (emailValid) {
      if (this.state.password === '') {
        this.setState({ displaytext: 'show_block' });
        this.setState({
          passwordErrorMessage: `${language.LC().Password_is_Required}`,
        });
        return;
      }
      if (this.state.repeatpassword === '') {
        this.setState({ displaytext: 'show_block' });
        this.setState({
          repPasswordErrorMessage: `${language.LC().Confirm_Password_is_Required}`,
        });
        return;
      }
      if (this.state.password !== this.state.repeatpassword) {
        this.setState({ displaytext: 'show_block' });
        this.setState({
          repPasswordErrorMessage: `${language.LC().Password_didnt_match}`,
        });
        return;
      }
      if (this.state.password.length < 6) {
        this.setState({ displaytext: 'show_block' });
        this.setState({
          passwordErrorMessage: `${language.LC().Please_enter_atleast_6_characters_in_the_field}`,
        });
        return;
      }
      // if (document.getElementById("examlocate").value === "") {
      //   this.setState({ displaytext: "show_block" });
      //   this.setState({ locErrorMessage: "Exam Location is Required" });
      //   return;
      // }
      if (document.getElementById('exam_field').value === '') {
        this.setState({ displaytext: 'show_block' });
        this.setState({
          examErrorMessage: `${language.LC().Exam_Field_is_Required}`,
        });
        return;
      }

      const role = localStorage.getItem('role');
      const organizationDomain = localStorage.getItem('organizationDomain');
      var examValue = document.getElementById('exam_field').value;

      var data = {
        name: this.state.username,
        email: this.state.email,
        password: this.state.password,
        exam: examValue,
        role: role,
        organizationDomain: organizationDomain,
        landingSource: this.state.landingSource,
        landingSourceName: this.state.landingSourceName,
      };
      const userData = JSON.parse(localStorage.getItem('userData'));
      var loginData = {
        idname: this.state.email,
        password: this.state.password,
        role: role,
        organizationDomain: organizationDomain,
      };
      FD.callAPI(App_data.backend_api + '/user/signup', data).then((resp) => {
        console.log('singnup reponseing {}==========>', resp);
        if (resp.success) {
          localStorage.setItem('loginID', resp.loginID);
          localStorage.removeItem('previousPath');
          // if (this.state.landingSource) {
          /*
          -------------------------
          GTM signup event code
          -------------------------
          */
          const tagManagerArgs = {
            gtmId: GTM_ID,
            dataLayer: {
              event: GTMSignUp,
              eventOptions: {
                selectedExam: document.getElementById('exam_field').value,
              },
              userName: this.state.username,
              userEmail: this.state.email,
              userExam: document.getElementById('exam_field').value,
              source: this.state.landingSource,
              affiliateName: this.state.landingSourceName,
            },
          };
          TagManager.initialize(tagManagerArgs);
          // ************* Sign Up event for GA4 ****************** //
          const tagManagerArgsGA4 = {
            gtmId: GTM_ID,
            dataLayer: {
              event: GA4SignUp,
              method: this.state.email,
            },
          };
          TagManager.initialize(tagManagerArgsGA4);
          // }
          localStorage.setItem('signup', 1);
          FD.callAPI(App_data.backend_api + '/user/login', loginData).then((response) => {
            console.log('first login api', response);
            if (response.success) {
              localStorage.setItem('loginID', response.loginID);
              var localStorage_array = {
                token: response.token,
                idname: this.state.email,
              };
              localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
              localStorage.setItem('selectedmenu', examValue);
              console.log(this.state.urlToRedirect);
              const examField = examValue;
              if (this.state.urlToRedirect !== null && this.state.urlToRedirect !== undefined) {
                browserHistory.push({
                  pathname: this.state.urlToRedirect,
                  state: {
                    token: response.token,
                    idname: this.state.email,
                  },
                });
              } else if (examObject[examField]) {
                browserHistory.push({
                  pathname:
                    examObject[examField].sidebarRoutes.dashboard || AppRoutes.CFA1_2024_DASHBOARD,
                });
              }
            }
            // else if (!response.success && response.partner) {
            //   this.signUpAlertModel();
            //   this.setState({
            //     username: "",
            //     email: "",
            //     password: "",
            //     repeatpassword: "",
            //     message: "",
            //     userNameErrorMessage: "",
            //     emailErrorMessage: "",
            //     passwordErrorMessage: "",
            //     repPasswordErrorMessage: "",
            //     locErrorMessage: "",
            //     examErrorMessage: "",
            //     urlToRedirect: "",
            //   });
            // }
          });
        } else {
          this.setState({ displaytext: 'show_block' });
          this.setState({ message: resp.message });
        }
      });
    } else {
      this.setState({ displaytext: 'show_block' });
      this.setState({ emailErrorMessage: `${language.LC().Email_Id_Invalid}` });
      return;
    }
  }

  updateUserName(e) {
    this.setState({
      username: e.target.value,
      userNameErrorMessage: '',
    });
  }
  updateEmail(e) {
    var email_lower = e.target.value.toLowerCase();
    this.setState({
      email: email_lower,
      emailErrorMessage: '',
    });
  }
  updatePassword(e) {
    this.setState({
      password: e.target.value,
      passwordErrorMessage: '',
    });
  }
  updateRepeatPassword(e) {
    this.setState({
      repeatpassword: e.target.value,
      repPasswordErrorMessage: '',
    });
  }

  async responseGoogleGIS(response) {
    console.log('============response============', response);
    const role = localStorage.getItem('role');
    const organizationDomain = localStorage.getItem('organizationDomain');
    const landingSource = localStorage.getItem('landingSource');
    const landingSourceName = localStorage.getItem('landingSourceName');

    const credential = (response && response.credential) ? response.credential : '';
    const idPayload = parseIdToken(credential);
    const email = (idPayload && idPayload.email) ? idPayload.email : '';
    const name = (idPayload && idPayload.name) ? idPayload.name : email;

    const data = {
      credential: credential,
      role: role,
      organizationDomain: organizationDomain,
    };

    try {
      const resp = await FD.callAPI(
          App_data.backend_api + '/user/v2/loginWithSocialMedia',
          data
      );

      if (!resp || !resp.success) {
        if (resp && resp.partner && resp.message) {
          alert(resp.message);
        } else {
          alert('Login failed. Please try again.');
        }
        return;
      }

      if (resp.loginID) {
        localStorage.setItem('loginID', resp.loginID);
      }

      // cookies + localStorage
      const cookies = new Cookies();
      cookies.set('token', resp.token, { path: '/', maxAge: 60 * 60 * 24 });
      if (email) {
        cookies.set('idname', email, { path: '/', maxAge: 60 * 60 * 24 });
      }
      localStorage.setItem('localstorageval', JSON.stringify({ token: resp.token, idname: email }));

      if (resp.user_data == null) {
        localStorage.setItem('signup', 1);
        browserHistory.push({
          pathname: '/selectexam',
          state: { token: resp.token, idname: email, name: name, landingSource: landingSource, landingSourceName: landingSourceName },
        });
        return;
      }

      const prof = await FD.callAPI(
          App_data.backend_api + '/user/getProfileInfo',
          { token: resp.token, idname: email }
      );

      if (!prof || !prof.success || !prof.profileInfo || !prof.profileInfo.exam) {
        localStorage.setItem('signup', 1);
        browserHistory.push({
          pathname: '/selectexam',
          state: { token: resp.token, idname: email, name: name, landingSource: landingSource, landingSourceName: landingSourceName },
        });
        return;
      }

      var hasUrlRedirect = this && this.state && this.state.urlToRedirect != null;
      if (hasUrlRedirect) {
        var examField = prof.profileInfo.exam;
        if (examObject && examObject[examField]) {
          browserHistory.push({
            pathname: (examObject[examField].sidebarRoutes && examObject[examField].sidebarRoutes.dashboard) || AppRoutes.CFA1_2024_DASHBOARD,
          });
          return;
        }
      }

      localStorage.setItem('selectedmenu', prof.profileInfo.exam);
      browserHistory.push({
        pathname: examRedirectRoute[prof.profileInfo.exam],
        state: { token: resp.token, idname: email },
      });
    } catch (err) {
      console.error('GIS login error', err);
      alert('Login failed. Please try again.');
    }
  }


  responseGoogle(response) {
    console.log('============response============', response);
    const role = localStorage.getItem('role');
    const organizationDomain = localStorage.getItem('organizationDomain');
    const userData = JSON.parse(localStorage.getItem('userData'));
    const landingSource = localStorage.getItem('landingSource');
    const landingSourceName = localStorage.getItem('landingSourceName');
    var data = {
      name: response.profileObj.name,
      email: response.profileObj.email,
      token: response.accessToken,
      imageUrl: response.profileObj.imageUrl,
      organizationDomain: organizationDomain,
      role: role,
    };
    FD.callAPI(App_data.backend_api + '/user/loginWithSocialMedia', data)
      .then((resp) => {
        if (resp.success) {
          localStorage.setItem('loginID', resp.loginID);
          var localStorage_array = {
            token: resp.token,
            idname: response.profileObj.email,
          };
          const cookies = new Cookies();
          cookies.set('token', resp.token, {
            path: '/',
            maxAge: 60 * 60 * 24,
          });
          cookies.set('idname', response.profileObj.email, {
            path: '/',
            maxAge: 60 * 60 * 24,
          });
          localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
          if (resp.user_data == null) {
            localStorage.setItem('signup', 1);
            browserHistory.push({
              pathname: '/selectexam',
              state: {
                token: resp.token,
                idname: response.profileObj.email,
                name: response.profileObj.name,
                landingSource: landingSource,
                landingSourceName: landingSourceName,
              },
            });
          } else {
            var data = { token: resp.token, idname: response.profileObj.email };
            FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then((resp) => {
              if (resp.success) {
                if (this.state.urlToRedirect !== null) {
                  if (examObject[examField]) {
                    browserHistory.push({
                      pathname:
                        examObject[examField].sidebarRoutes.dashboard ||
                        AppRoutes.CFA1_2024_DASHBOARD,
                    });
                  }
                } else if (resp.profileInfo.exam) {
                  localStorage.setItem('selectedmenu', resp.profileInfo.exam);
                  browserHistory.push({
                    pathname: examRedirectRoute[resp.profileInfo.exam],
                    state: {
                      token: resp.token,
                      idname: response.profileObj.email,
                    },
                  });
                }
              } else {
                console.log('fail');
              }
            });
          }
        } else if (!resp.success && resp.partner) {
          alert(resp.message);
        }
      })
      .catch(function (err) {});
  }

  failedGoogle(response) {
    console.log('Failed googles login', response);
    if (response.details === 'Cookies are not enabled in current environment.') {
      alert(
        "We've detected a problem with your cookie settings in the browser. Make sure that your cookies are enabled.",
      );
    }
  }

  togglepassword = (val) => {
    if (this.state.inputValue == val) this.setState({ inputValue: undefined });
    else this.setState({ inputValue: val });
  };

  render() {
    // console.log(this.props.urlToRedirect)
    // console.log("th.landingSource", this.state.landingSource);
    // console.log(localStorage.getItem("domainName"));
    // console.log(localStorage.getItem("domainApp"));
    var domainApp = localStorage.getItem('domainApp');
    return (
      <div className='sign-up-input-tile'>
        {
          <div className='social-button-tile'>
            <GoogleBtn
                onSuccess={this.responseGoogleGIS}
                onFailure={this.failedGoogle}
            />
            {/*<GoogleLogin*/}
            {/*  className='social-button pointer_class'*/}
            {/*  style={{ width: 100 + '%' }}*/}
            {/*  clientId='104176560344-vjgtqbi1ga22rf4646q2pvrj73okfagb.apps.googleusercontent.com'*/}
            {/*  buttonText={*/}
            {/*    <div>*/}
            {/*      <span className='social-button-img'>*/}
            {/*        <img src={App_data.frontend_url + '/img/google-plus.png'} alt='' />*/}
            {/*      </span>*/}
            {/*      Sign in with Google*/}
            {/*    </div>*/}
            {/*  }*/}
            {/*  onSuccess={this.responseGoogle}*/}
            {/*  onFailure={this.failedGoogle}*/}
            {/*/>*/}
          </div>
        }

        <form className='sign-up-form-wrap' onSubmit={this.Registration}>
          <p className={this.state.displaytext + ' text-danger'}>{this.state.message}</p>
          <div className='form-group'>
            <input
              type='text'
              className='form-control'
              placeholder={language.LC().USERNAME}
              value={this.state.username}
              onChange={this.updateUserName}
            />
            <p className={this.state.displaytext + ' text-danger'}>
              {this.state.userNameErrorMessage}
            </p>
          </div>
          <div className='form-group'>
            <input
              type='text'
              className='form-control'
              placeholder={language.LC().EMAIL}
              value={this.state.email}
              onChange={this.updateEmail}
            />
            <p className={this.state.displaytext + ' text-danger'}>
              {this.state.emailErrorMessage}
            </p>
          </div>
          <div className='form-group'>
            <div className='passwordeye_wrapper'>
              <input
                type={this.state.inputValue == 1 ? 'text' : 'password'}
                className='form-control'
                placeholder={language.LC().PASSWORD}
                value={this.state.password}
                onChange={this.updatePassword}
              />
              {this.state.inputValue == 1 ? (
                <img
                  onClick={() => this.togglepassword('1')}
                  src={App_data.frontend_url + '/img/show 2.png'}
                  alt=''
                />
              ) : (
                <img
                  onClick={() => this.togglepassword('1')}
                  src={App_data.frontend_url + '/img/hide2.png'}
                  alt=''
                />
              )}
            </div>
            <p className={this.state.displaytext + ' text-danger'}>
              {this.state.passwordErrorMessage}
            </p>
          </div>
          <div className='form-group'>
            <div className='passwordeye_wrapper'>
              <input
                type={this.state.inputValue == 2 ? 'text' : 'password'}
                className='form-control'
                placeholder={language.LC().CONFIRM_PASSWORD}
                value={this.state.repeatpassword}
                onChange={this.updateRepeatPassword}
              />
              {this.state.inputValue == 2 ? (
                <img
                  onClick={() => this.togglepassword('2')}
                  src={App_data.frontend_url + '/img/show 2.png'}
                  alt=''
                />
              ) : (
                <img
                  onClick={() => this.togglepassword('2')}
                  src={App_data.frontend_url + '/img/hide2.png'}
                  alt=''
                />
              )}
            </div>
            <p className={this.state.displaytext + ' text-danger'}>
              {this.state.repPasswordErrorMessage}
            </p>
          </div>

          <div className='form-group'>
            <select className='form-control' id='exam_field'>
              {[
                { value: '', label: language.LC().SELECT_EXAM },
                ...CFAExamList(),
                ...FRMExamList,
                ...ActuarialExamList,
                ...GMATExamList,
              ].map(({ value, label }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
            <p className={this.state.displaytext + ' text-danger'}>{this.state.examErrorMessage}</p>
          </div>
          <button className='btn btn-primary sign-up-button btn-block' type='submit'>
            {language.LC().SIGN_UP}
          </button>
        </form>
        <SignUpApproval
          signUpAlertModel={this.signUpAlertModel.bind(this)}
          signUpAlertModelClose={this.signUpAlertModelClose.bind(this)}
          signupAlert={this.state.signupAlert}
        />
      </div>
    );
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/views/Pages/Auth/SignUp.js